
/* Oct 19 (Jacob): Candy Cane page = model hero clip (desktop crop / phone vertical cut) + spin-to-win.
   Every wheel slot is a real Shopify code: CANDY10 (10%), CANDYSHIP (free shipping), CANDY15 (15%), once per customer, through Dec 31 2026.
   Weighted pick (10% 45 / ship 35 / 15% 20), then the wheel lands on a matching slot. One spin per browser (localStorage). */
(function(){
  var PRIZES=[{c:'CANDY10',t:'10% off'},{c:'CANDYSHIP',t:'Free shipping'},{c:'CANDY15',t:'15% off'},{c:'CANDY10',t:'10% off'},{c:'CANDYSHIP',t:'Free shipping'},{c:'CANDY15',t:'15% off'}];
  var W={CANDY10:45,CANDYSHIP:35,CANDY15:20},KEY='esCcWheel';
  function get(){try{return JSON.parse(localStorage.getItem(KEY)||'null')}catch(e){return null}}
  function put(v){try{localStorage.setItem(KEY,JSON.stringify(v))}catch(e){}}
  function root(){return document.getElementById('view-candycane')}
  function q(sel){var r=root();return r?r.querySelector(sel):null}
  function showResult(r,instant){
    var res=q('.cc-wres'),spin=q('.cc-wspin');if(!res)return;
    q('.cc-wres-t').textContent='You won '+r.t.toLowerCase()+'!';
    q('.cc-wcode-v').textContent=r.c;
    res.hidden=false;spin.hidden=true;
    var wh=q('.cc-wheel');if(instant&&wh){wh.style.transition='none';wh.style.transform='rotate('+r.rot+'deg)'}
  }
  window.ccWheelOpen=function(src){
    var m=q('.cc-wmodal');if(!m)return;
    m.hidden=false;try{sessionStorage.setItem('esCcWheelSeen','1')}catch(e){}
    var r=get();if(r)showResult(r,true);
    var t=q('.cc-wtab');if(t)t.hidden=true;
    setTimeout(function(){var b=q('.cc-wspin:not([hidden])')||q('.cc-wapply');if(b)b.focus()},50);
  };
  window.ccWheelClose=function(){var m=q('.cc-wmodal');if(m)m.hidden=true;var t=q('.cc-wtab');if(t)t.hidden=false};
  window.ccWheelSpin=function(){
    if(get()){showResult(get(),true);return}
    var tot=0,k,pick,r=Math.random()*100;for(k in W){tot+=W[k];if(r<tot){pick=k;break}}pick=pick||'CANDY10';
    var segs=[];PRIZES.forEach(function(p,i){if(p.c===pick)segs.push(i)});
    var i=segs[Math.floor(Math.random()*segs.length)],center=i*60+30,jit=Math.round(Math.random()*36-18);
    var rot=360*6-center+jit;
    var wh=q('.cc-wheel'),btn=q('.cc-wspin');btn.disabled=true;
    wh.style.transform='rotate('+rot+'deg)';
    var res={c:PRIZES[i].c,t:PRIZES[i].t,rot:rot%360,ts:Date.now()};put(res);
    try{if(window.esTrack&&esTrack.event)esTrack.event('cc_wheel_spin',{prize:res.c})}catch(e){}
    setTimeout(function(){btn.disabled=false;showResult(res,false)},window.matchMedia&&matchMedia('(prefers-reduced-motion: reduce)').matches?50:4300);
  };
  window.ccWheelCopy=function(){var v=q('.cc-wcode-v').textContent,n=q('.cc-wnote');try{navigator.clipboard.writeText(v);n.textContent='Copied '+v+'.'}catch(e){n.textContent='Your code: '+v}};
  window.ccWheelApply=function(){
    var r=get(),n=q('.cc-wnote');if(!r)return;n.textContent='Applying…';
    fetch('/discount/'+encodeURIComponent(r.c),{credentials:'same-origin'}).then(function(){n.textContent=r.c+' is applied. You’ll see it at checkout.'}).catch(function(){n.textContent='Use code '+r.c+' at checkout.'});
  };
  document.addEventListener('keydown',function(e){if(e.key==='Escape'){var m=q('.cc-wmodal');if(m&&!m.hidden)ccWheelClose()}});
  document.addEventListener('click',function(e){var m=q('.cc-wmodal');if(m&&!m.hidden&&e.target===m)ccWheelClose()});
  /* auto-open once per session on the candy cane page: 10s, half scroll, or exit intent; waits for the Klaviyo popup */
  var armed=false,t0=0;
  function klOpen(){return window.current!=='candycane'&&document.body.classList.contains('klaviyo-prevent-body-scrolling')}
  /* Oct 20 (Jacob): no email signup on the candy cane page, only the spinner. Hide the Klaviyo popup + teaser there. */
  setInterval(function(){var on=window.current==='candycane';document.documentElement.classList.toggle('cc-nokl',on);if(on)document.body.classList.remove('klaviyo-prevent-body-scrolling')},300);
  function seen(){try{return !!sessionStorage.getItem('esCcWheelSeen')}catch(e){return false}}
  function tryOpen(){if(window.current!=='candycane'||seen()||get()||klOpen())return;ccWheelOpen('auto')}
  function setHero(){
    var v=q('.cc-vid-hero');if(!v||v.getAttribute('src'))return;
    var mob=window.matchMedia&&matchMedia('(max-width: 700px)').matches;
    if(mob)v.setAttribute('poster',v.getAttribute('data-pm'));
    v.setAttribute('src',v.getAttribute(mob?'data-m':'data-d'));
    var p=v.play();if(p&&p.catch)p.catch(function(){});
  }
  setInterval(function(){
    var on=window.current==='candycane';
    if(on&&!armed){armed=true;t0=Date.now();setHero();var tab=q('.cc-wtab');if(tab)tab.hidden=!!(seen()&&false)}
    if(!on&&armed){armed=false;var tb=q('.cc-wtab');if(tb)tb.hidden=true}
    if(on){
      var tab2=q('.cc-wtab'),hero=q('.cc-hero');if(tab2&&q('.cc-wmodal').hidden)tab2.hidden=!(hero&&hero.getBoundingClientRect().bottom<0);
      if(Date.now()-t0>10000)tryOpen();
      var h=document.documentElement;if(h.scrollTop/(h.scrollHeight-innerHeight||1)>.5)tryOpen();
    }
  },500);
  document.addEventListener('mouseout',function(e){if(!e.relatedTarget&&e.clientY<8)tryOpen()});
})();
